import { getQueryParams, httpApi } from '@api/FW/http.api';

export type ChangePasswordByEmailStart = {
	baseUrl: string;
	email: string;
	login: string;
	recaptcha: string | null | undefined;
};

export const changePasswordByEmailStart = (data: ChangePasswordByEmailStart): Promise<any> =>
	httpApi
		.post<any>(
			'ChangePasswordByEmail/Start',
			{
				BaseUrl: data.baseUrl,
				Email: data.email,
				Login: data.login,
				'g-recaptcha-response': data.recaptcha,
			},
			{ params: getQueryParams() },
		)
		.then(({ data }) => {
			//console.log(data)
			return data;
		})
		.catch((err) => {
			throw err;
		});

export const changePasswordByEmailFinish = (password: string, id: string): Promise<any> =>
	httpApi
		.post<any>(
			'ChangePasswordByEmail/Finish',
			{
				Password: password,
				ID: id,
			},
			{ params: getQueryParams() },
		)
		.then(({ data }) => {
			//console.log(data)
			return data;
		})
		.catch((err) => {
			throw err
		});
